import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../../Button/index.jsx';
import styles from './style.module.scss';

const Step = props =>
	<div className={cx(styles.step, {
    [styles.display]: props.display ? true:false
  })}>
    {props.children}
    <div className={styles.navigation}>
      {props.displayPrev
        ?
        <div className={cx({
          [styles.button]: true,
          [styles.margin]: props.displayPrev && props.displayNext
        })}>
          <Button onClick={props.handlePrev}>
            {props.prevText ? props.prevText:"Back"}
          </Button>
        </div>
        :null}
      {props.displayNext 
        ?
          <div className={cx({
            [styles.button]: true,
            [styles.margin]: props.displayPrev && props.displayNext
          })}>
            <Button onClick={props.handleNext}>
              {props.nextText ? props.nextText:"Next"}
            </Button>
          </div>
        :null}
    </div>
  </div>

Step.propTypes = {
    display: PropTypes.bool.isRequired,
    displayNext: PropTypes.bool,
    displayPrev: PropTypes.bool,
    nextText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    prevText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    handleNext: PropTypes.func,
    handlePrev: PropTypes.func,
}

export default Step;